export class SellerCurrentBalanceModel {
    balance: number = 0

    constructor(s?:Partial<SellerCurrentBalanceModel>) {
        Object.assign(this, s)
    }
}
